angular.module('leanlaw').controller('SummaryOverviewController', ['$scope', '$rootScope', '$q', '$window', '$filter', "$timeout", '$location', '$stateParams', '$state', "alerts", "userService", "reportsService", "leanLawApi", "messageBus", "ModalService", "singleRequest", function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, alerts, userService, reportsService, leanLawApi, messageBus, ModalService, singleRequest) {
  $scope.gotoMatter = matter => {
    $state.go("reports.client-summary", {
      clientId: $stateParams.clientId,
      matterId: matter.id,
      return: $state.current.name,
      backParams: $stateParams
    });
  };
  function load() {
    $scope.loading = true;
    userService.me().then(function (me) {
      $scope.trust = me.company.settings.trustEnabled;
      $scope.accounting = me.company.integration.quickbooks;
      var loading = [];
      var query = queryFromFilter();
      if (!query) return; // Not ready yet

      $scope.data = null;
      $scope.matters = null;
      query.billed = 'any';
      query.billedState = undefined;
      query.primary = 'clients';
      query.zeros = true;
      query.data = 'hours,services,charges,expenses';
      loading.push(singleRequest.apiCall("getclientmatter").getReport(query).then(data => {
        if (!data) return; // Cancelled
        $scope.data = data.clients.length ? data.clients[0] : data.data;
        if ($scope.cm.matter) {
          $scope.data = $scope.data.matters[0];
          $scope.matters = null;
        } else {
          $scope.matters = $scope.data.matters;
        }
        $scope.loading = false;
      }));
      if ($scope.accounting) {
        $scope.accountingData = null;
        query.data = 'lastPayment,receivables';
        if ($scope.trust) {
          query.data += ',trust';
        }
        query.primary = 'clients';
        loading.push(singleRequest.apiCall("getaccounting").getReport(query).then(data => {
          if (!data) return; // Cancelled
          $scope.accountingData = data.clients.length ? data.clients[0].data.accounting : data.data.accounting;
          if ($scope.cm.matter && !$scope.cm.client.billing.billClient) {
            $scope.accountingData = data.clients[0].matters[0].data.accounting;
          }
        }));
      }
      $scope.users = null;
      query.primary = 'users';
      query.data = 'hours,services,cost';
      loading.push(singleRequest.apiCall('usersummary').getReport(query).then(data => {
        if (!data) return; // Cancelled
        $scope.users = data;
      }));
      return $q.all(loading);
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    var query = reportsService.queryFromFilter($scope.filter);
    if (!query) return;
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    load();
  });
  $scope.$watch("cm", newValue => {
    load();
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);
}]);